import { render, staticRenderFns } from "./ChatTextarea.vue?vue&type=template&id=e2439280&scoped=true"
import script from "./ChatTextarea.vue?vue&type=script&lang=js"
export * from "./ChatTextarea.vue?vue&type=script&lang=js"
import style0 from "./ChatTextarea.vue?vue&type=style&index=0&id=e2439280&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2439280",
  null
  
)

export default component.exports